import styled from "styled-components";
import { hexToRGB } from "./util";

import { usePopperTooltip } from "react-popper-tooltip";
import "react-popper-tooltip/dist/styles.css";

import { Icon } from "@cti-workspace/ui";
import { TipText } from "./Typography";

export const LinkButton = styled.a`
	font-family: Roboto;
	font-weight: bold;
	font-size: 0.9rem;
	font-style: normal;
	line-height: 1.03rem;
	color: ${(props) => hexToRGB(props.color || "#000", props.opacity || 0.87)};
	text-decoration-line: none;
	border: none;
	background-color: transparent;
	padding: 0.25em 1em;
	cursor: pointer; /* Pointer/hand icon */
	@media (max-width: 768px) {
		font-size: 0.75rem;
	}
`;

export const HeaderButtonGroup = styled.div`
	> a {
		background-color: transparent;
		border-right: 1px solid #e0e0e0;
		padding: 0.6rem 1rem; /* Some padding */
		float: left; /* Float the buttons side by side */
		@media (max-width: 768px) {
			padding: 0.6em;
		}
		&:hover {
		}

		&:last-child {
			border-right: none; /* Prevent last borders */
		}
	}

	&:after {
		display: table;
	}
`;

export const FooterButtonGroup = styled.div`
	@media (max-width: 992px) {
		// for larger screens
		> a {
			color: white; /* White text */
			padding: 0.6rem 1rem; /* Some padding */
			width: 100%; /* Set a width if needed */
			display: block; /* Make the buttons appear below each other */

			&:hover {
			}

			&:last-child {
			}
		}
		width: auto;
		height: auto;
		margin: 0 auto;
		padding: 10px;
		position: relative;
		text-align: center;
	}

	@media (min-width: 992px) {
		// for larger screens
		> a {
			background-color: transparent;
			border-right: 0.5px solid #e0e0e0;
			color: ${({ theme }) => theme?.footerColor || "white"};
			padding: 0.6rem 1rem; /* Some padding */
			cursor: pointer; /* Pointer/hand icon */
			float: left; /* Float the buttons side by side */

			&:hover {
			}

			&:last-child {
				border-right: none; /* Prevent double borders */
			}
		}

		&:after {
			clear: both;
			display: table;
		}
	}
`;

const MainButton = styled.button`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px 30px;
	gap: 10px;
	flex: 1;
	border-radius: 8px;
	cursor: pointer; /* Pointer/hand icon */
	:disabled {
		opacity: 0.2;
		cursor: not-allowed;
	}
`;

export const PrintButton = styled(MainButton)`
	background: #ffffff;
	border: 1px solid ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorOpacity)};
	color: ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorOpacity)};
	padding: 0.8rem;
`;

export const VerifyButton = styled(MainButton)`
	/* Adapt the colors based on primary prop */
	background: ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorOpacity)};
	color: ${(props) => ContrastColor(props.theme.primaryColor)};
	border: 1px solid ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorOpacity)};
	border-radius: 8px;
	padding: 0.8rem;
`;

export const ContrastColor = (c) => ["black", "white"][~~([1, 3, 5].map((p) => parseInt(c.substr(p, 2), 16)).reduce((r, v, i) => [0.299, 0.587, 0.114][i] * v + r, 0) < 128)];

export const LinkedInButton = styled(MainButton)`
	background: #0072b1;
	border: 1px solid rgba(163, 182, 204, 0.2);
	color: ${() => ContrastColor("#0072b1")};
	font-weight: 700;
	padding: 0.8rem;
`;

export const IconButton = styled(MainButton)`
	background: #ffffff;
	border: 1px solid #e0e0e0;
`;

export const ShareButton = ({ theme, icon, iconSize = 30, iconWeight = "fill", iconColor = "#000", onClick = () => null, toolTipText, disabled = false }) => {
	const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip();

	return (
		<>
			<IconButton theme={theme} type="button" ref={setTriggerRef} onClick={onClick} disabled={disabled}>
				<Icon name={icon} size={iconSize} weight={iconWeight} color={iconColor} />
			</IconButton>
			{visible && (
				<div ref={setTooltipRef} {...getTooltipProps({ className: "tooltip-container" })}>
					<div {...getArrowProps({ className: "tooltip-arrow" })} />
					<TipText color="#757575">{toolTipText}</TipText>
				</div>
			)}
		</>
	);
};
